<!-- @format -->

<div class="course-unit-grade-raise-info" *ngIf="courseUnit$ | async as data">
  <div class="sis-px-xxs">
    <span
      ><sis-icon icon="check" color="success"></sis-icon
      >{{ "PLAN.GRADE_RAISE_COMPLETION_METHOD_CHOSEN" | transloco: { completion_method_index: getCompletionMethodIndex(data) } }}</span
    >
    <sis-button (clicked)="openDialog(data)" [naked]="true" [size]="'sm'">{{
      getOpenDialogTranslationKeyWhenCompletionMethodSelected(data) | transloco
    }}</sis-button>
  </div>
</div>
